module.exports = __webpack_public_path__ + "static/media/view-info.415b027d.ico";